import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  selectedTalkChannel: null,
}

export const validateTalkChannel = (active, state) => ({
  talkChannels:
    active && state.talkChannelAccounts.length === 0 && '톡채널을 연동하세요.',
  selectedTalkChannel:
    active &&
    !state.selectedTalkChannel &&
    '비즈채널에 연동된 톡채널을 선택하세요.',
})

export const getTalkChannelAssetData = state => ({
  type: 'TALK_CHANNEL',
  data: {
    uuid: state.selectedTalkChannel,
  },
})

const talkChannelSlice = createSlice({
  name: 'talkChannel',
  initialState,
  reducers: {
    reset: () => initialState,
    selectTalkChannel: (state, { payload: uuid }) => {
      state.selectedTalkChannel = uuid
    },
    setTalkChannel: (state, { payload: { uuid } }) => {
      state.selectedTalkChannel = uuid
    },
  },
})

export const { reset, selectTalkChannel, setTalkChannel } =
  talkChannelSlice.actions

export default talkChannelSlice.reducer
